import React from 'react';
import {MDBCard} from 'mdbreact';

class App extends React.Component {
  render() {
    return (
      <MDBCard className='my-5 px-5 pb-5 over'>
        <h1 className='contactPageh1'>Contact Us</h1>
        <div class='md-form md-outline'>
          <input
            type='text'
            id='form1'
            placeholder='Naam'
            className='form-control'
          />
          <br />
          <input
            type='email'
            id='form1'
            placeholder='Email'
            className='form-control'
          />
          <br />
          <textarea
            id='form75'
            className='Ctextarea md-textarea form-control'
            rows='3'
            placeholder='Message'
          ></textarea>
        </div>
      </MDBCard>
    );
  }
}

export default App;
